import {Component, Input, OnInit} from "@angular/core";
import {PedidosService} from "../../services/pedidos.service";

@Component({
  selector: 'app-sincronizar-keeta-status',
  templateUrl: './sincronizar-keeta.component.html',
  styleUrls: ['./sincronizar-keeta.component.scss']
})
export class SincronizarKeetaComponent implements OnInit {
  @Input() pedido: any = {}

  constructor(private pedidosService: PedidosService) {

  }

  ngOnInit(): void {
  }

  async sincronizarStatusPedido($event: any) {

    this.pedido.sincronizando = true;

    this.pedidosService.sincronizePedidoKeeta( this.pedido).then((resposta: any) => {
      this.pedido.sincronizando = false;
      if(resposta && resposta.id)
        Object.assign( this.pedido, resposta);
    }).catch((err) => {
      this.pedido.sincronizando = false;
    });

    $event.stopPropagation();
    $event.preventDefault();

    return false;
  }

}
